var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timestamp"},[_c('span',{staticClass:"prevMonth"},[_vm._v(" < ")]),_c('span',{staticClass:"timestampContent"},[_vm._v(" "+_vm._s(1-1-1)+" ")]),_c('span',{staticClass:"nextMonth"},[_vm._v(" > ")])])}
var staticRenderFns = []

export { render, staticRenderFns }